import React from 'react';
import { bool, func, string, node } from 'prop-types';
import { anonymousFunc } from '../../utils/helpers';

const LinkButton = ({ loading, icon, onClick, label, additionalClass }) => {
  return (
    <button
      onClick={loading ? anonymousFunc : onClick}
      type="button"
      className={`co-primary bg-white borderless ${additionalClass}`}
    >
      {icon && (
        <span
          style={{
            marginRight: '0.3rem',
            
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          {icon}
        </span>
      )}
      <b>{label}</b>
    </button>
  );
};

LinkButton.propTypes = {
  onClick: func.isRequired,
  label: string.isRequired,
  additionalClass: string,
  loading: bool,
  icon: node,
};

LinkButton.defaultProps = {
  additionalClass: '',
  icon: null,
};

export default LinkButton;
